import React, { Component } from "react";
import { observer } from "mobx-react";
import {
    fn_devliery_connect_send, fn_devliery_connect_add_reset
} from "function/FnBodyDelivery";

@observer
class DlvConnectAdd extends Component {
    constructor(props) {
        super(props);
        this.inputFocus = React.createRef();
    }
    searchKeyPressNum = (e) => {
        const input = document.getElementById("RegistNum");
        const regex = /[^0-9]/g;
        input.value = e.target.value.replace(regex, "");
    };
    render() {

        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;
        const buttonClass = rootStore.settingStore.getDlvRegistInfo.businessNumber.length === 10 ? "on" : "off";

        return (
            <div className={"layer_comm layer_common_type alert" + (layerStore.getDlvConnectAdd ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="wrap">
                        <div className="top">
                            <p>배달대행사 추가</p>
                            <div className="btn_close btn_close_comm">
                                <button
                                    onClick={event => {
                                        fn_devliery_connect_add_reset(rootStore); 
                                        rootStore.layerStore.setDlvConnectAdd(false); 
                                        rootStore.settingStore.setDlvConnectResult("");
                                        rootStore.deliveryStore.setDlvConnectCode([]); 
                                    }}
                                ><span>닫기</span></button>
                            </div>
                        </div>
                        <div className="content_business">
                            <p>
                                {rootStore.settingStore.getDlvRegistInfo.deliveryServiceName} 연동을 위해<br />
                            </p>
                            <p>사업자번호를 입력해주세요.</p>
                            <div className="input">
                                <div>사업자번호</div>
                                <input id="RegistNum" type="text" className="print" placeholder="숫자를 입력해주세요"
                                onChange={event => {
                                    this.searchKeyPressNum(event);
                                    rootStore.settingStore.setDlvRegistInfo("businessNumber", event.target.value)
                                }} maxLength="10" />
                            </div>
                            <div className={(rootStore.settingStore.getDlvConnectResult == "warning") ? "error_message" : "hide"}>
                                <div className="icon"></div>
                                <div className="txt">
                                    <p>매장 정보와 사업자 번호가 일치하지 않습니다.</p>
                                    <p>고객센터로 문의주세요.
                                     {
                                        layerStore.tp === "WMP" ? "(1833-4877)" : "(1544-3583)"
                                     }
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="bussiness_bottom">
                            <div>
                                <div className="divider"></div>
                            </div>
                            <div className="btn_business">
                                <button 
                                    onClick={event => {
                                        fn_devliery_connect_add_reset(rootStore);
                                        rootStore.settingStore.setDlvConnectResult("");
                                        rootStore.layerStore.setDlvConnectAdd(false);
                                        rootStore.deliveryStore.setDlvConnectCode([]); 
                                    }}>취소</button>

                                <button 
                                    className={buttonClass}
                                    disabled={buttonClass === "off"}
                                    onClick={event => {
                                        fn_devliery_connect_send(rootStore, document.getElementById("RegistNum").value);
                                    }}>연동하기</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DlvConnectAdd;